import { themr } from '@friendsofreactjs/react-css-themr';

import ScreenLoader from './ScreenLoader';

export default themr('ScreenLoader')(ScreenLoader);
